import { IButtonConfig, IButtonConfigClickHandler } from '../../components/list-view/list-view-button-config.model';
import { StructureComponent } from '../../../views/site/structure/structure.component';
import { DrawerComponentLiaisonBase } from '../drawers/drawer-base-classes';    

// Note:  some click handlers also need to implement interface IDrawerComponentLiaison.
/*
export class DrawerComponentLiaisonBase {
    // Properties.
    private initializationComplete: boolean = false;

    // Constructor.
    protected constructor() { }

    // Implement part of interface IDrawerComponentLiaison.
    public get LiaisonHasInitialized(): boolean {
        return this.initializationComplete;
    }

    // Implement methods available to derived classes.
    protected initializationHasCompleted(): void {
        this.initializationComplete = true;
    }
    protected initializationHasStarted(): void {
        this.initializationComplete = false;
    }
}
*/

export abstract class StructureButtonConfigClickHandlerBase extends DrawerComponentLiaisonBase implements IButtonConfigClickHandler {
    // Constructor.
    public constructor(protected structureComponent: StructureComponent) {
        super();
    }

    // Implement IButtonConfigHandler methods.
    public handlePreButtonClick(): void {
        this.initializationHasStarted();
    }

    public abstract handleButtonClick(buttonConfig: IButtonConfig, eventData: any, contextItem: any): void;
}
